import React, { useState, useEffect, useCallback, useRef } from "react";
import ReactDataGrid from "@inovua/reactdatagrid-community";
import "@inovua/reactdatagrid-community/base.css";
import "@inovua/reactdatagrid-community/index.css";
import "@inovua/reactdatagrid-community/theme/default-dark.css";
import NumberFilter from "@inovua/reactdatagrid-community/NumberFilter";
import DateFilter from "@inovua/reactdatagrid-community/DateFilter";
import SelectFilter from "@inovua/reactdatagrid-community/SelectFilter";
import "./Movements.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  Container,
  Row,
  Col,
  Form,
  Dropdown,
  OverlayTrigger,
  Tooltip,
  Button,
} from "react-bootstrap";
import { exportPDF_movements, exportCSV_movements } from "../excelExport.js";
import { RiFileExcel2Line } from "react-icons/ri";
import { ImFilePdf } from "react-icons/im";
import moment from "moment";

function Movements() {
  //putting a test comment here for VC check
  const tokenString = sessionStorage.getItem("token");
  const userToken = JSON.parse(tokenString);
  const Username = userToken.username;
  const UserID = userToken.userId;
  const userSites = userToken.sites;

  // Styles and setup for grids
  const gridStyle = {
    minHeight: "79vh",
    margin: 10,
  };
  const gridStyle2 = {
    minHeight: "35vh",
    margin: 10,
  };

  const theme = "default-dark";
  const [dataSource, setDataSource] = useState([]);
  const [productSearch, setProductSearch] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [movementType, setMovementType] = useState("");
  const [orderFilter, setOrderFilter] = useState("");

  const [formattedEndDate, setFormattedEndDate] = useState(
    new Date().toISOString().slice(0, 10)
  );
  const [formattedStartDate, setFormattedStartDate] = useState(
    new Date().toISOString().slice(0, 10)
  );

  // Store reference to grids for exporting PDF/CSV
  const [gridRef_movements, setGridRef_movements] = useState(null);

  const handleProductSearchChange = (event) => {
    setProductSearch(event.target.value);
  };

  const handleOrderSearchChange = (event) => {
    setOrderFilter(event.target.value);
  };

  const handleSetEndDate = (rawDate) => {
    const date = new Date(rawDate);
    const formattedDateEnd = date.toISOString().slice(0, 10);
    //cant pass this parsed date back to datepicker or it will crash
    // need to save it to another value
    setEndDate(rawDate);
    setFormattedEndDate(formattedDateEnd);
  };

  const handleSetStartDate = (rawDate) => {
    const date = new Date(rawDate);
    const formattedStartDate = date.toISOString().slice(0, 10);
    //cant pass this parsed date back to datepicker or it will crash
    // need to save it to another value
    setStartDate(date);
    setFormattedStartDate(formattedStartDate);
  };

  const [movements, setMovements] = useState([]);
  const handleMovementFilterChange = (event) => {
    const selectedMovement =
      event.target.options[event.target.selectedIndex].getAttribute("data-key");

    if (selectedMovement === "") {
      setMovementType(""); // set to null or whatever default value you want
    } else {
      setMovementType(selectedMovement);
    }
  };

  const selectRef = useRef(null);
  const orderInput = useRef(null);
  const productInput = useRef(null);

  const handleClearFilters = () => {
    setProductSearch("");
    setStartDate("");
    setEndDate("");
    setMovementType("");
    setOrderFilter("");
    setFormattedEndDate("");
    setFormattedStartDate("");
    selectRef.current.value = "";
    productInput.current.value = "";
    orderInput.current.value = "";
  };

  useEffect(() => {
    // const rawDate = new Date();
    // const formattedDate = rawDate.toISOString().slice(0, 10);

    // setStartDate(rawDate);
    // setEndDate(rawDate);
    // setFormattedEndDate(formattedDate);
    // setFormattedStartDate(formattedDate);

    fetchData();

    fetch("/getMovements")
      .then((response) => response.json())
      .then((data) => {
        //alert(JSON.stringify(data))
        setMovements(data);
      })
      .catch((error) => console.error(error));
  }, []);

  const fetchData = async () => {
    // Build the query based on the input state variables
    console.log("productSearch : " + JSON.stringify(productSearch));
    const response = await fetch(
      `/test?userID=${UserID}&productSearch=${productSearch}&startDate=${formattedStartDate}&endDate=${formattedEndDate}${
        movementType ? `&movementType=${movementType}` : ""
      }&orderFilter=${orderFilter}`
    );

    // CR: Filter the data to show only movements for the users sites
    const data = await response.json().then((data) => {
      return data.filter((movement) => {
        return userSites.includes(movement.Site);
      });
    });

    // Update the state with the filtered data
    console.log("filtered data returned: ", data);
    setDataSource(data);
  };

  useEffect(() => {
    fetchData();
  }, [
    productSearch,
    formattedStartDate,
    formattedEndDate,
    movementType,
    orderFilter,
  ]);

  const handleCopyToClipboard = (data) => {
    //alert('Copied Data : '+JSON.stringify(data));
    navigator.clipboard.writeText(data);
  };

  const renderRowContextMenu = useCallback(
    (menuProps, { rowProps, columnProps }) => {
      menuProps.autoDismiss = true;
      menuProps.items = [
        {
          label: "Copy Order Number ",
          onClick: () => handleCopyToClipboard(rowProps.data.OrderNum),
        },
        {
          label: "Copy Product Code ",
          onClick: () => handleCopyToClipboard(rowProps.data.Product),
        },
        {
          label: "Copy Description ",
          onClick: () => handleCopyToClipboard(rowProps.data.Description),
        },
        {
          label: "Copy Location  ",
          onClick: () => handleCopyToClipboard(rowProps.data.Location),
        },
        {
          label: "Copy Quantity ",
          onClick: () => handleCopyToClipboard(rowProps.data.Description),
        },
      ];
    },
    []
  );

  const movementTypes = movements.reduce((movementTypes, movement) => {
    if (!movementTypes.some((c) => c.id === movement.Description)) {
      movementTypes.push({
        id: movement.Description,
        label: movement.Description,
      });
    }
    return movementTypes;
  }, []);

  const columns = [
    {
      name: "Type",
      header: "Type",
      type: "string",
      defaultFlex: 0,
      filterEditor: SelectFilter,
      filterEditorProps: {
        placeholder: "All",
        dataSource: movementTypes,
        filterFn: (value, rowData, column) => {
          return rowData[column.dataKey] === value;
        },
      },
    },
    { name: "OrderNum", header: "Order", type: "string", defaultFlex: 0 },
    { name: "Product", header: "Product", type: "number", defaultFlex: 0 },
    {
      name: "Description",
      header: "Description",
      type: "string",
      defaultFlex: 1,
    },
    { name: "Location", header: "Location", type: "string", defaultFlex: 0 },
    {
      name: "Qty",
      header: "Quantity",
      type: "number",
      defaultFlex: 0,
      filterEditor: NumberFilter,
    },
    // { name:'Date', header:'Date', defaultFlex: 0,
    //   // need to specify dateFormat
    //   dateFormat: 'DD/MM/YYYY',
    //   filterEditor: DateFilter,
    //   filterEditorProps: (props, { index }) => {
    //     // for range and notinrange operators, the index is 1 for the after field
    //     return {
    //       dateFormat: 'DD/MM/YYYY',
    //       cancelButton: true,
    //       highlightWeekends: true,
    //       placeholder : 'Filter Date'
    //     }
    //   }
    // }
    {
      name: "Date",
      header: "Date",
      type: "string",
      defaultFlex: 0,
      dateFormat: "DD/MM/YYYY HH:mm:ss",
      filterable: false,
    },
  ];

  const defaultFilterValue = [
    { name: "Type", operator: "eq", type: "string", value: "" },
    { name: "OrderNum", operator: "startsWith", type: "string", value: "" },
    { name: "Product", operator: "startsWith", type: "string", value: "" },
    { name: "Description", operator: "startsWith", type: "string", value: "" },
    { name: "Location", operator: "startsWith", type: "string", value: "" },
    { name: "Qty", operator: "startsWith", type: "number", value: "" },
  ];
  const defaultSortInfo = { name: "Date", dir: -1, type: "date" };

  // Function to clear all column filters
  // Function to clear all column filters
  const refreshGrid = () => {
    setDataSource([]);
    fetchData();
  };

  return (
    <div>
      <div className="filter" style={{ display: "none" }}>
        <Container>
          <Row>
            <Col>
              <Form.Label>Product Search:</Form.Label>
              <Form.Control
                size="sm"
                type="text"
                placeholder="Search..."
                ref={productInput}
                onChange={handleProductSearchChange}
              />
            </Col>
            <Col>
              <Form.Label>Start Date:</Form.Label>
              <DatePicker
                selected={startDate}
                dateFormat="dd/MM/yyyy"
                onChange={handleSetStartDate}
              />
            </Col>
            <Col>
              <Form.Label>End Date:</Form.Label>
              <DatePicker
                selected={endDate}
                dateFormat="dd/MM/yyyy"
                onChange={handleSetEndDate}
              />
            </Col>
            <Col>
              <Form.Label>Movement Type:</Form.Label>
              <Form.Control
                as="select"
                style={{ display: "inline", marginBottom: 10, width: "90%" }}
                onChange={handleMovementFilterChange}
                ref={selectRef}
              >
                <option value="">Select movement</option>
                {movements.map((movement) => (
                  <option
                    key={movement.WMSCode}
                    value={movement.Description}
                    data-key={movement.WMSCode}
                  >
                    {movement.Description}
                  </option>
                ))}
              </Form.Control>
            </Col>
            <Col>
              <Form.Label>Order Filter:</Form.Label>
              <Form.Control
                size="sm"
                type="text"
                placeholder="Search..."
                ref={orderInput}
                onChange={handleOrderSearchChange}
              />
            </Col>
            <Col>
              {/* Export to PDF (Stock Grid) */}
              <OverlayTrigger
                key="PDFEXPORT"
                placement="bottom"
                overlay={<Tooltip id="tooltip-pdf">Movements to PDF</Tooltip>}
              >
                <Button
                  variant="secondary"
                  style={{
                    margin: "5px",
                    marginTop: "0px",
                    border: "1px solid black",
                  }}
                  onClick={() => {
                    const gridData = gridRef_movements;
                    exportPDF_movements(gridData);
                  }}
                >
                  <ImFilePdf />
                </Button>
              </OverlayTrigger>
              <OverlayTrigger
                key="CSVEXPORT"
                placement="bottom"
                overlay={
                  <Tooltip id="tooltip-excel">Movements to Excel</Tooltip>
                }
              >
                <Button
                  variant="secondary"
                  style={{
                    margin: "5px",
                    marginTop: "0px",
                    border: "1px solid black",
                  }}
                  onClick={() => {
                    const gridData = gridRef_movements;
                    exportCSV_movements(gridData);
                  }}
                >
                  <RiFileExcel2Line />
                </Button>
              </OverlayTrigger>
              <Button onClick={refreshGrid}>Reload Data</Button>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="exportAndRefresh" style={{ marginTop: 10 }}>
        <Container>
          <Row>
            <Col>
              <Form.Label>Start Date:</Form.Label>
              <DatePicker
                selected={startDate}
                dateFormat="dd/MM/yyyy"
                onChange={handleSetStartDate}
              />
            </Col>
            <Col>
              <Form.Label>End Date:</Form.Label>
              <DatePicker
                selected={endDate}
                dateFormat="dd/MM/yyyy"
                onChange={handleSetEndDate}
              />
            </Col>
            {/* <Col>
                    <Row>
                      <Button onClick={handleClearFilters}>
                        Clear Date Filters
                      </Button>
                    </Row>
                    
                  </Col> */}
            <Col>
              {/* Export to PDF (Stock Grid) */}
              <OverlayTrigger
                key="PDFEXPORT"
                placement="bottom"
                overlay={<Tooltip id="tooltip-pdf">Movements to PDF</Tooltip>}
              >
                <Button
                  variant="secondary"
                  style={{
                    margin: "5px",
                    marginTop: "0px",
                    border: "1px solid black",
                  }}
                  onClick={() => {
                    const gridData = gridRef_movements;
                    exportPDF_movements(gridData);
                  }}
                >
                  <ImFilePdf />
                </Button>
              </OverlayTrigger>
              <OverlayTrigger
                key="CSVEXPORT"
                placement="bottom"
                overlay={
                  <Tooltip id="tooltip-excel">Movements to Excel</Tooltip>
                }
              >
                <Button
                  variant="secondary"
                  style={{
                    margin: "5px",
                    marginTop: "0px",
                    border: "1px solid black",
                  }}
                  onClick={() => {
                    const gridData = gridRef_movements;
                    exportCSV_movements(gridData);
                  }}
                >
                  <RiFileExcel2Line />
                </Button>
              </OverlayTrigger>
              <Button onClick={refreshGrid}>Reload Data</Button>
            </Col>
          </Row>
        </Container>
      </div>

      <div>
        <ReactDataGrid
          idProperty="ID"
          columns={columns}
          dataSource={dataSource}
          style={gridStyle}
          theme={theme}
          rowSelection="single"
          handle={setGridRef_movements}
          renderRowContextMenu={renderRowContextMenu}
          enableFiltering={true}
          defaultFilterValue={defaultFilterValue}
          defaultSortInfo={defaultSortInfo}
        />
      </div>
    </div>
  );
}

export default Movements;
